import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { MedicalReferralsFilters } from 'Images';
import { AdvancedSearchIcon, FilterIcon } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IAdvancedSearch {
  openAdvancedSearch: Function;
}

export const AdvancedSearchTitle = ({
  openAdvancedSearch,
}: IAdvancedSearch) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      position='relative'
      width='fit-content'
      alignSelf={'flex-end'}
      direction='row'
      alignItems='center'
      gap='4px'
      sx={{ cursor: 'pointer' }}
      onClick={() => {
        openAdvancedSearch(true);
      }}
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={0}
    >
      <Avatar
        alt=''
        src={MedicalReferralsFilters}
        sx={{
          width: isDesktop ? '24px' : '18px',
          height: isDesktop ? '24px' : '18px',
        }}
      />
      <Typography color={'primary.main'} variant={'body2'}>
        {Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.title}
      </Typography>
    </Stack>
  );
};
